var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisclaimerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    strokeWidth: 0,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.02.16a1.86 1.86 0 0 0-1.86 1.86v28.06a1.86 1.86 0 0 0 1.86 1.86h20.29a1.86 1.86 0 0 0 1.86-1.86v-7.97c-.09-.45 0-16.07 0-16.07a.62.62 0 0 0-.18-.43L22.73.34a.62.62 0 0 0-.44-.18zm.2 2.07h15.05v4.19c0 .42.34.76.77.76h4.07v22.69H6.23z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11 5.18h5.9a.76.76 0 0 0 0-1.51h-5.9a.76.76 0 1 0 0 1.51m11.22 2.17a.76.76 0 0 0-.75-.76H9.14a.76.76 0 0 0 0 1.51h10.44a.76.76 0 0 0 .75-.75m-11.2 3.78h5.9a.76.76 0 1 0 0-1.51h-5.9a.76.76 0 0 0 0 1.51",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.45 15.33a6.32 6.32 0 0 0-6.31 6.31 6.32 6.32 0 0 0 6.31 6.31 6.32 6.32 0 0 0 6.31-6.31c0-3.48-2.83-6.31-6.31-6.31m0 11.21a4.91 4.91 0 0 1-4.91-4.9 4.91 4.91 0 0 1 4.91-4.91 4.91 4.91 0 0 1 4.9 4.91 4.91 4.91 0 0 1-4.9 4.9",
    opacity: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.52 22.78a2.27 2.27 0 0 1-1.96 1.12 2.27 2.27 0 0 1-2.26-2.26 2.27 2.27 0 0 1 2.26-2.27c.8 0 1.55.43 1.96 1.12l.05.09h1.52l-.09-.24a3.66 3.66 0 0 0-3.44-2.38 3.68 3.68 0 0 0-3.67 3.68 3.68 3.68 0 0 0 5.76 3.02A3.65 3.65 0 0 0 17 22.93l.09-.24h-1.52z",
    opacity: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.17 25.23 1.78-.25q.28 1.28.88 1.79.61.53 1.65.53 1 0 1.56-.52.58-.51.58-1.2 0-.51-.36-.93-.61-.74-3.36-2.42-1.46-.9-2.04-1.4-.57-.52-.94-1.21-.36-.7-.36-1.45 0-.94.59-1.71t1.62-1.08q-.7-.68-.98-1.24-.29-.57-.29-1.21 0-1.27.99-2.2t2.62-.93q1.85 0 2.89.88t1.24 2.56l-1.85.18q-.21-1.2-.73-1.68-.52-.47-1.39-.47-.91 0-1.47.49t-.56 1.08q0 .51.36.95.55.67 3.02 2.17 1.55.95 2.1 1.4.7.59 1.02 1.22.34.63.34 1.37 0 1.12-.72 1.91-.42.46-1.52.92.79.6 1.17 1.3.4.69.4 1.48 0 .87-.49 1.64-.5.78-1.43 1.18-.93.42-2.01.42-1.88 0-2.99-.95-1.11-.94-1.32-2.62m5.78-3.1q.73-.38 1.09-.87.36-.5.36-.98 0-.56-.51-1.19-.53-.62-2.23-1.66-1.35-.83-2.01-1.37-.81.46-1.15.91-.34.46-.34 1.01 0 .62.46 1.18.45.57 2.05 1.51 1.32.78 2.28 1.46",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimerIcon);
export default __webpack_public_path__ + "static/media/Disclaimer_icon.5993fba395cb8c6726a39cd500262323.svg";
export { ForwardRef as ReactComponent };